import 'css-chunksrc/client/scenes/projectCreationForm/projectStatus/statusList/styles.scss';export default {
  "status": "_status_aaz2z_1",
  "topElement": "_topElement_aaz2z_15",
  "folder": "_folder_aaz2z_23",
  "folderIcon": "_folderIcon_aaz2z_28",
  "name": "_name_aaz2z_35",
  "description": "_description_aaz2z_41",
  "icon": "_icon_aaz2z_45"
};